import { render, staticRenderFns } from "./SavePageButton.vue?vue&type=template&id=5d69a8c8&scoped=true"
import script from "./SavePageButton.vue?vue&type=script&lang=js"
export * from "./SavePageButton.vue?vue&type=script&lang=js"
import style0 from "./SavePageButton.vue?vue&type=style&index=0&id=5d69a8c8&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d69a8c8",
  null
  
)

export default component.exports